import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "flex flex-col gap-2" }
const _hoisted_2 = { class: "font-bold mb-4" }
const _hoisted_3 = { class: "flex flex-col h-full md:flex-row gap-8 p-8" }
const _hoisted_4 = { class: "grid grid-cols w-4/6" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "flex w-full" }, null, -1)
const _hoisted_6 = { class: "flex flex-col gap-8" }
const _hoisted_7 = { class: "flex flex-col items-center" }
const _hoisted_8 = { class: "rounded-lg w-[40%] aspect-square hover:scale-105 transition-all overflow-clip relative" }
const _hoisted_9 = ["src"]
const _hoisted_10 = ["src"]
const _hoisted_11 = { class: "flex justify-between" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("button", { class: "px-4 py-2 bg-green-700 text-white hover:bg-green-600 focus:bg-green-600 rounded" }, " Subir ", -1)
const _hoisted_13 = { class: "flex flex-col items-center gap-4" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("h1", { class: "font-bold" }, "Código QR de registro de residentes", -1)
const _hoisted_15 = { class: "w-64 h-64" }
const _hoisted_16 = {
  ref: "qr-link",
  class: "object-cover w-full h-full"
}
const _hoisted_17 = { class: "flex flex-row w-full gap-4" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("h3", { class: "font-bold mb-4 mt-4" }, "Control de acceso", -1)
const _hoisted_19 = { class: "flex justify-end mr-2" }
const _hoisted_20 = { class: "flex px-4 py-2 text-gray-700" }
const _hoisted_21 = { class: "flex justify-end" }
const _hoisted_22 = ["onClick"]
const _hoisted_23 = ["onClick"]
const _hoisted_24 = { class: "flex justify-between" }
const _hoisted_25 = ["disabled"]
const _hoisted_26 = { class: "flex justify-between" }
const _hoisted_27 = ["disabled"]
const _hoisted_28 = { key: 0 }
const _hoisted_29 = {
  key: 1,
  class: "icon-spin"
}
const _hoisted_30 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-spinner fa-spin" }, null, -1)
const _hoisted_31 = [
  _hoisted_30
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TextField = _resolveComponent("TextField")!
  const _component_mdicon = _resolveComponent("mdicon")!
  const _component_InputFile = _resolveComponent("InputFile")!
  const _component_Modal = _resolveComponent("Modal")!
  const _component_ComponentCard = _resolveComponent("ComponentCard")!
  const _component_ModalAlert = _resolveComponent("ModalAlert")!
  const _component_Accordion = _resolveComponent("Accordion")!
  const _component_AddButton = _resolveComponent("AddButton")!
  const _component_Alert = _resolveComponent("Alert")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_ComponentCard, null, {
      header: _withCtx(() => [
        _createElementVNode("h3", _hoisted_2, "Comunidad: " + _toDisplayString(_ctx.communityUpdate.name), 1)
      ]),
      default: _withCtx(() => [
        _createElementVNode("section", _hoisted_3, [
          _createElementVNode("aside", _hoisted_4, [
            _createVNode(_component_TextField, {
              label: "Nombre de la comunidad",
              model: _ctx.communityUpdate.name,
              "onUpdate:model": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.communityUpdate.name) = $event)),
              type: "text",
              name: "name",
              onInput: _cache[1] || (_cache[1] = ($event: any) => (_ctx.handleInput()))
            }, null, 8, ["model"]),
            _createVNode(_component_TextField, {
              name: "razón social",
              model: _ctx.communityUpdate.businessName,
              "onUpdate:model": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.communityUpdate.businessName) = $event)),
              label: "Razón social",
              type: "text",
              onInput: _cache[3] || (_cache[3] = ($event: any) => (_ctx.handleInput()))
            }, null, 8, ["model"]),
            _createVNode(_component_TextField, {
              class: "sm:w-48",
              name: "rut",
              model: _ctx.communityUpdate.rut,
              "onUpdate:model": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.communityUpdate.rut) = $event)),
              label: "RUT",
              type: "text",
              onInput: _cache[5] || (_cache[5] = ($event: any) => (_ctx.handleInput()))
            }, null, 8, ["model"]),
            _createVNode(_component_TextField, {
              name: "Dirección",
              label: "Dirección",
              model: _ctx.communityUpdate.address,
              "onUpdate:model": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.communityUpdate.address) = $event)),
              type: "text",
              onInput: _cache[7] || (_cache[7] = ($event: any) => (_ctx.handleInput()))
            }, null, 8, ["model"]),
            _hoisted_5,
            _createVNode(_component_TextField, {
              class: "h-full",
              label: "Descripción",
              model: _ctx.communityUpdate.description,
              "onUpdate:model": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.communityUpdate.description) = $event)),
              type: "textarea",
              name: "description",
              onInput: _cache[9] || (_cache[9] = ($event: any) => (_ctx.handleInput()))
            }, null, 8, ["model"]),
            (_ctx.isModified)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 0,
                  onClick: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.updateHandleCommunity && _ctx.updateHandleCommunity(...args))),
                  class: "px-4 py-2 bg-green-700 text-white hover:bg-green-600 focus:bg-green-600 rounded"
                }, " Actualizar "))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("figure", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, [
                (_ctx.communityUpdate.thumbnail != null)
                  ? (_openBlock(), _createElementBlock("img", {
                      key: 0,
                      src: `${_ctx.getEnvConfig().apiURL}/${_ctx.communityUpdate.thumbnail}`,
                      class: "object-cover"
                    }, null, 8, _hoisted_9))
                  : (_openBlock(), _createElementBlock("img", {
                      key: 1,
                      src: `${
                  _ctx.getEnvConfig().apiURL
                }/media/community/community/community.png`,
                      class: "object-cover"
                    }, null, 8, _hoisted_10)),
                _createVNode(_component_mdicon, {
                  name: "plus-circle",
                  class: "absolute bottom-0 right-0 text-success hover:text-green-500 focus:text-green-500 rounded-full cursor-pointer",
                  size: "50",
                  onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.showModal = true)),
                  visible: _ctx.showModal
                }, null, 8, ["visible"])
              ]),
              _createVNode(_component_Modal, {
                title: "Subir thumbnail",
                visible: _ctx.showModal,
                "onUpdate:visible": _cache[13] || (_cache[13] = (e) => _ctx.showModal = e)
              }, {
                footer: _withCtx(() => [
                  _createElementVNode("div", _hoisted_11, [
                    _createElementVNode("button", {
                      class: "px-4 py-2 mr-2 bg-gray-300 hover:bg-gray-400 focus:bg-gray-400 rounded",
                      onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.showModal = false))
                    }, " Cancelar "),
                    _hoisted_12
                  ])
                ]),
                default: _withCtx(() => [
                  _createVNode(_component_InputFile, {
                    label: "imagen",
                    onUploadFile: _ctx.updateThumbnail
                  }, null, 8, ["onUploadFile"])
                ]),
                _: 1
              }, 8, ["visible"])
            ]),
            _createElementVNode("div", _hoisted_13, [
              _hoisted_14,
              _createElementVNode("div", _hoisted_15, [
                _createElementVNode("img", _hoisted_16, null, 512)
              ]),
              _createElementVNode("button", {
                class: "bg-success text-white px-6 py-2 font-semibold rounded-md hover:scale-105 transition-all",
                onClick: _cache[14] || (_cache[14] = ($event: any) => (_ctx.downloadQRCode()))
              }, " Descargar ")
            ])
          ])
        ])
      ]),
      _: 1
    }),
    (_ctx.success)
      ? (_openBlock(), _createBlock(_component_ModalAlert, {
          key: 0,
          visible: _ctx.success,
          option: true,
          onAccept: _ctx.handleAcceptSuccess
        }, null, 8, ["visible", "onAccept"]))
      : _createCommentVNode("", true),
    _createElementVNode("section", _hoisted_17, [
      _createVNode(_component_ComponentCard, { class: "flex w-3/6 p-2" }, {
        default: _withCtx(() => [
          _createElementVNode("section", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.items, (item, index) => {
              return (_openBlock(), _createElementBlock("div", {
                key: index,
                class: "m-2"
              }, [
                _createVNode(_component_Accordion, {
                  items: [item],
                  "header-color": 'bg-success',
                  "onUpdate:modelValue": _ctx.updateAccordion
                }, null, 8, ["items", "onUpdate:modelValue"])
              ]))
            }), 128))
          ])
        ]),
        _: 1
      }),
      _createVNode(_component_ComponentCard, { class: "flex w-3/6" }, {
        default: _withCtx(() => [
          _createElementVNode("section", null, [
            _hoisted_18,
            _createElementVNode("header", _hoisted_19, [
              _createVNode(_component_AddButton, { onClick: _ctx.addItem }, null, 8, ["onClick"])
            ]),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.formattedControlAccess, (item, index) => {
              return (_openBlock(), _createElementBlock("article", {
                key: index,
                class: "m-2"
              }, [
                _createVNode(_component_Accordion, {
                  items: [item],
                  headerColor: 'bg-success'
                }, {
                  content: _withCtx(() => [
                    _createElementVNode("div", _hoisted_20, [
                      _createElementVNode("p", null, _toDisplayString(item.content), 1)
                    ])
                  ]),
                  footer: _withCtx(() => [
                    _createElementVNode("footer", _hoisted_21, [
                      _createElementVNode("button", {
                        class: "flex px-4 py-2 mb-2 text-sm font-medium text-white bg-warning rounded-md hover:bg-yellow-600 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-warning",
                        onClick: ($event: any) => (_ctx.editItem(index))
                      }, " Editar ", 8, _hoisted_22),
                      _createElementVNode("button", {
                        class: "flex px-4 py-2 ml-2 mr-2 mb-2 text-sm font-medium text-white bg-danger rounded-md hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-danger",
                        onClick: ($event: any) => (_ctx.deleteItem(index))
                      }, " Eliminar ", 8, _hoisted_23)
                    ]),
                    _createVNode(_component_ModalAlert, {
                      title: 'Eliminar consulta',
                      message: '¿Esta seguro de eliminar esta consulta?',
                      visible: _ctx.showAlertModal,
                      onAccept: _ctx.handleAccept,
                      onCancelAlert: _cache[15] || (_cache[15] = ($event: any) => (_ctx.showAlertModal = false))
                    }, null, 8, ["visible", "onAccept"])
                  ]),
                  _: 2
                }, 1032, ["items"])
              ]))
            }), 128))
          ])
        ]),
        _: 1
      })
    ]),
    _createVNode(_component_Modal, {
      title: "Agregar control de acceso",
      visible: _ctx.showModalAdd,
      "onUpdate:visible": _cache[20] || (_cache[20] = (e) => _ctx.showModalAdd = e)
    }, {
      default: _withCtx(() => [
        _createVNode(_component_TextField, {
          label: "Nombre",
          model: _ctx.nameField,
          "onUpdate:model": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.nameField) = $event)),
          type: "text",
          name: "name"
        }, null, 8, ["model"]),
        _createVNode(_component_TextField, {
          label: "Descripción",
          model: _ctx.descriptionField,
          "onUpdate:model": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.descriptionField) = $event)),
          type: "textarea",
          name: "name"
        }, null, 8, ["model"])
      ]),
      footer: _withCtx(() => [
        _createElementVNode("div", _hoisted_24, [
          _createElementVNode("button", {
            class: "px-4 py-2 mr-2 bg-danger hover:bg-red-700 text-white focus:bg-red-700 rounded-md",
            onClick: _cache[18] || (_cache[18] = ($event: any) => (_ctx.showModalAdd = false))
          }, " Cancelar "),
          _createElementVNode("button", {
            class: _normalizeClass(["px-4 py-2 bg-success text-white hover:bg-green-700 focus:bg-green-700 rounded-md", {
              'opacity-50 cursor-not-allowed disabled:pointer-events-none':
                !_ctx.isFieldsFilled,
            }]),
            onClick: _cache[19] || (_cache[19] = 
//@ts-ignore
(...args) => (_ctx.saveAddItem && _ctx.saveAddItem(...args))),
            disabled: !_ctx.isFieldsFilled
          }, " Agregar ", 10, _hoisted_25)
        ])
      ]),
      _: 1
    }, 8, ["visible"]),
    _createVNode(_component_Modal, {
      title: "Editar control de acceso",
      visible: _ctx.showModalEdit,
      "onUpdate:visible": _cache[25] || (_cache[25] = (e) => _ctx.showModalEdit = e)
    }, {
      default: _withCtx(() => [
        _createVNode(_component_TextField, {
          label: "Nombre",
          model: _ctx.nameField,
          "onUpdate:model": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.nameField) = $event)),
          type: "text",
          name: "name"
        }, null, 8, ["model"]),
        _createVNode(_component_TextField, {
          label: "Descripción",
          model: _ctx.descriptionField,
          "onUpdate:model": _cache[22] || (_cache[22] = ($event: any) => ((_ctx.descriptionField) = $event)),
          type: "textarea",
          name: "name"
        }, null, 8, ["model"])
      ]),
      footer: _withCtx(() => [
        _createElementVNode("div", _hoisted_26, [
          _createElementVNode("button", {
            class: "px-4 py-2 mr-2 bg-gray-300 hover:bg-gray-400 text-white focus:bg-gray-400 rounded-md",
            onClick: _cache[23] || (_cache[23] = ($event: any) => (_ctx.showModalEdit = false))
          }, " Cancelar "),
          _createElementVNode("button", {
            class: _normalizeClass(["px-4 py-2 bg-green-500 text-white hover:bg-green-700 focus:bg-green-700 rounded-md", {
              'opacity-50 cursor-not-allowed disabled:pointer-events-none':
                !_ctx.isFieldsFilled,
            }]),
            onClick: _cache[24] || (_cache[24] = 
//@ts-ignore
(...args) => (_ctx.saveEditItem && _ctx.saveEditItem(...args))),
            disabled: !_ctx.isFieldsFilled
          }, [
            (!_ctx.loading)
              ? (_openBlock(), _createElementBlock("span", _hoisted_28, "Editar"))
              : (_openBlock(), _createElementBlock("span", _hoisted_29, _hoisted_31))
          ], 10, _hoisted_27)
        ])
      ]),
      _: 1
    }, 8, ["visible"]),
    (_ctx.showAlert)
      ? (_openBlock(), _createBlock(_component_Alert, {
          key: 1,
          type: _ctx.typeAlert,
          message: _ctx.messageAlert
        }, null, 8, ["type", "message"]))
      : _createCommentVNode("", true)
  ]))
}